

export const archetypes = [
    {name: 'Arachnos Soldier', base_hp: 1070.9, max_hp: 2409.5, max_regen: 2000, regen_tick: 5.5},
    {name: 'Arachnos Widow', base_hp: 1070.9, max_hp: 2409.5, max_regen: 2000, regen_tick: 5.5},
    {name: 'Blaster', base_hp: 1204.8, max_hp: 1606.4, max_regen: 2000, regen_tick: 5},
    {name: 'Brute', base_hp: 1499.3, max_hp: 3212.7, max_regen: 2500, regen_tick: 5},
    {name: 'Controller', base_hp: 1017.4, max_hp: 1606.4, max_regen: 2000, regen_tick: 5},
    {name: 'Corruptor', base_hp: 1070.9, max_hp: 1606.4, max_regen: 2000, regen_tick: 5},
    {name: 'Defender', base_hp: 1017.4, max_hp: 1606.4, max_regen: 2000, regen_tick: 5},
    {name: 'Dominator', base_hp: 1017.4, max_hp: 1606.4, max_regen: 2000, regen_tick: 5},
    {name: 'Mastermind', base_hp: 803.2, max_hp: 1606.4, max_regen: 2000, regen_tick: 5},
    {name: 'Peacebringer', base_hp: 1070.9, max_hp: 2409.5, max_regen: 2000, regen_tick: 5},
    {name: 'Scrapper', base_hp: 1338.6, max_hp: 2409.5, max_regen: 3000, regen_tick: 5},
    {name: 'Stalker', base_hp: 1204.8, max_hp: 2088.3, max_regen: 3000, regen_tick: 5},
    {name: 'Tanker', base_hp:  	1874.1, max_hp: 3534, max_regen: 2500, regen_tick: 5},
    {name: 'Warshade', base_hp: 1070.9, max_hp: 2409.5, max_regen: 2000, regen_tick: 5}
];

export function regen_hps(hp, regen, tick_pct) {
    const denom = regen / 100;
    const interval = 12 / denom;
    const amount = (tick_pct / 100) * hp;
    const hps = amount / interval;
    return Math.round(hps * 100) / 100;
}
